import { YouTubeVideoData } from './youtube-video-data.model';

export class YouTubeVideo {
  id: string;
  title: string;
  description: string;
  thumbnailUrl: string;
  videoUrl: string;

  constructor(obj?: YouTubeVideoData) {
    this.id = obj?.id ?? '';
    this.title = obj?.title ?? '';
    this.description = obj?.description ?? '';
    this.thumbnailUrl = obj?.thumbnailUrl ?? '';
    this.videoUrl = obj?.videoUrl || `https://www.youtube.com/watch?v=${this.id}`;
  }
}
